<template>
	<v-textarea
		dense
		:hide-details="hideDetails"
		v-model="inputValue"
		:error="errorBorder"
		:error-messages="$props.error"
		:label="$props.label"
		:placeholder="$props.placeholder"
		:rows="$props.rows"
		:readonly="readonly"
		:type="$props.type"
	></v-textarea>
</template>

<script>
export default {
	name: 'TextArea',
	props: {
		value: String,
		readonly: Boolean,
		errorBorder: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: '',
		},
		placeholder: String,
		rows: [Number, String],
		label: String,
		type: String,
	},
	data() {
		return {
			inputValue: this.$props.value,
		};
	},
	computed: {
		hideDetails() {
			return this.$props.error === '';
		},
	},
	watch: {
		inputValue() {
			this.$emit('input', this.inputValue);
		},
		value() {
			this.inputValue = this.$props.value;
		},
	},
};
</script>

<style scoped></style>
